import type { MechKey } from './keys';

export const pt: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'Mecânica · 2D',
  'panel.scene': 'Cena',
  'panel.dims': 'Parâmetros',
  'panel.style': 'Aparência',
  'panel.action': 'Controles',
  'style.body': 'Corpo',
  'style.vector': 'Vetores',
  'style.ground': 'Solo',
  'style.forces': 'Mostrar forças',
  'style.trace': 'Mostrar rastro',
  'style.labels': 'Rótulos de vetores',
  'hint.line1': 'Clique em reproduzir para iniciar · arraste os corpos para movê-los',
  'hint.line2': 'Sandbox: escolha uma forma e clique para colocá-la',
  'scene.incline': 'Plano inclinado',
  'scene.projectile': 'Movimento de projétil',
  'scene.pendulum': 'Pêndulo',
  'scene.springMass': 'Sistema massa-mola',
  'scene.collisions': 'Colisões',
  'scene.atwood': 'Máquina de Atwood',
  'scene.circular': 'Movimento circular',
  'scene.sandbox': 'Sandbox',
  'dim.angle': 'ângulo (°)',
  'dim.friction': 'atrito',
  'dim.mass': 'massa',
  'dim.massA': 'massa A',
  'dim.massB': 'massa B',
  'dim.velocity': 'velocidade',
  'dim.angleLaunch': 'ângulo de lançamento (°)',
  'dim.gravity': 'gravidade',
  'dim.gravityX': 'gravidade x',
  'dim.gravityY': 'gravidade y',
  'dim.length': 'comprimento',
  'dim.damping': 'amortecimento',
  'dim.spring': 'rigidez',
  'dim.restitution': 'restituição',
  'dim.radius': 'raio',
  'dim.speed': 'rapidez',
  'action.play': 'Reproduzir',
  'action.pause': 'Pausar',
  'action.step': 'Passo',
  'action.reset': 'Redefinir',
  'action.speed': 'Velocidade',
  'action.clear': 'Limpar',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'Gravidade',
  'forceName.normal': 'Normal',
  'forceName.friction': 'Atrito',
  'forceName.tension': 'Tensão',
  'forceName.spring': 'Mola',
  'forceName.applied': 'Aplicada',
  'forceName.air': 'Resistência do ar',
  'palette.box': 'Caixa',
  'palette.circle': 'Bola',
  'palette.ramp': 'Rampa',
  'palette.ground': 'Solo',
  'palette.hint': 'Escolha uma forma e clique no canvas para colocá-la.',
  'panel.forces': 'Forças observadas',
  'forces.empty': 'Nenhuma ainda — reproduza a cena',
};
